<template>
    <div class="min-w-100">
        {{ text }}
    </div>
</template>

<script>
export default {
    name: "text-cell",
    props: {
        cell: {
            type: Object,
            required: true,
        },
        column: {
            type: Object,
            required: true,
        },
    },
    computed: {
        text() {
            let text = this.cell.text;
            return text ?? "-";
        },
    },
};
</script>